import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'
import clsx from 'clsx'
import CheckIcon from '@mui/icons-material/Check';

const useStyles = makeStyles(theme => ({
  label: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.text,
  },
  description: {
    marginTop: 10,
    display: 'block',
  },
  clientOption: {
    position: 'relative',
    cursor: 'pointer',
    '& > *': {
      cursor: 'pointer',
    },
    marginTop: 15,
    border: theme.border,
    borderRadius: theme.borderRadius,
    padding: 15,
    fontSize: theme.fontSizes.default,
    background: theme.backgroundColor,
    '&:first-of-type': {
      marginTop: 0,
    },
    '&:hover': {
      borderColor: theme.primary,
    },
  },
  selected: {
    background: theme.white,
    borderColor: theme.primary,
  },
  servicesTitle: {
    paddingTop: 10,
  },
  servicesList: {
    paddingLeft: 30,
    '& li': {
      listStyleType: 'disc',
    },
  },
  checkbox: {
    position: 'absolute',
    top: 15,
    right: 15,
    width: 24,
    height: 24,
    border: theme.border,
    borderRadius: '50%',
    backgroundColor: theme.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkboxSelected: {
    backgroundColor: theme.primary,
  },
  checkboxIcon: {
    height: 16,
    width: 16,
    color: theme.white,
  },
  clientInfoGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
    marginTop: 10
  },
  infoTitle: {
    fontSize: 12,
    color: theme.text,
    margin: 0,
    textTransform: 'uppercase',
    color: '#647190'
  },
  infoValue: {
    margin: '5px 0px'
  },
  servicesRow: {
    gridColumn: 'span 2'
  }
}))

const DatevClientSelectionItem = React.memo((props) => {
  const { className, client, isSelected, onChange, consultantNumber, clientNumber } = props
  const classes = useStyles()

  return (
    <div className={clsx(className, classes.clientOption, isSelected && classes.selected)} onClick={() => onChange?.(client)}>
      <div className={clsx(classes.checkbox, isSelected && classes.checkboxSelected)}>
        {isSelected && <CheckIcon className={classes.checkboxIcon} />}
      </div>
      <label className={classes.label}>{client.name}</label>
      <div className={classes.clientInfoGrid}>
        <div>
          <p className={classes.infoTitle}>{lang.accounting.datev.clientSelectionModal.consultantNumber}</p>
          <p className={classes.infoValue}>{consultantNumber}</p>
        </div>
        <div>
          <p className={classes.infoTitle}>{lang.accounting.datev.clientSelectionModal.clientNumber}</p>
          <p className={classes.infoValue}>{clientNumber}</p>
        </div>
        <div className={classes.servicesRow}>
          <p className={classes.infoTitle}>{lang.accounting.datev.clientSelectionModal.availableServices}</p>
          {client.services.map(service => (
            <p className={classes.infoValue} key={service.name}>{service.name}</p>
          ))}
        </div>
      </div>
    </div>
  )
})

DatevClientSelectionItem.propTypes = {
  className: PropTypes.string,
  isSelected: PropTypes.bool,
  onChange: PropTypes.func,
  description: PropTypes.string,
  client: PropTypes.shape({
    client_number: PropTypes.number.isRequired,
    consultant_number: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    services: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        scopes: PropTypes.arrayOf(PropTypes.string),
      })),
  }),
}

export default DatevClientSelectionItem
